import { render, staticRenderFns } from "./notNowPageTriangle.vue?vue&type=template&id=dbedbdfc&"
import script from "./notNowPageTriangle.vue?vue&type=script&lang=ts&"
export * from "./notNowPageTriangle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports